import { ajax } from '@/api/ajax';

export interface ManualTreeReq {
  /**
   * 手册编码
   */
  bookmapCode: string;
  /**
   * 手册版本
   */
  bookmapVersion: string;
  modelCode?: string;
  region?: string;
}

export interface ManualTreeResponse {
  childList: ManualTreeRecord[];
}

export interface ManualTreeRecord {
  /**
   * 信息结构类型：bookmap、chapter、topicref、topic
   */
  type: string;
  /**
   * 信息结构编码
   */
  code: string;
  uniqueCode: string;
  /**
   * 信息结构名称
   */
  name: string;
  /**
   * 信息结构版本
   */
  version: string;
  /**
   * 排序号
   */
  sort: number;
  /**
   * 是否有子节点
   */
  hasChildren: number;
  url?: string;
  /**
   * 子节点详情
   */
  childList?: ManualTreeRecord[];
}

export function getManualTree(data: ManualTreeReq) {
  return ajax<ManualTreeResponse>({
    url: '/api/tis/web/bookmap/tree',
    method: 'post',
    data: data
  });
}
